import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.CARGO_ITEMS].GET_CARGO_ITEMS]: {
		url: '/company/:companyId/cargo/:cargoId/items/',
	},

	[ModulesConfigMap[ModulesMap.CARGO_ITEMS].GET_CARGO_ITEM]: {
		url: '/company/:companyId/cargo/:cargoId/items/:cargoItemId/',
	},

	[ModulesConfigMap[ModulesMap.CARGO_ITEMS].GET_CARGO_ITEM_PREVIEW]: {
		url: '/company/:companyId/cargo/:cargoId/items/:cargoItemId/preview/',
	},

	[ModulesConfigMap[ModulesMap.CARGO_ITEMS].GET_CARGO_ITEM_POPUP]: {
		url: '/company/:companyId/cargo/:cargoId/items/:cargoItemId/popup/',
	},


	[ModulesConfigMap[ModulesMap.CARGO_ITEMS].CREATE_CARGO_ITEM]: {
		url: '/company/:companyId/cargo/:cargoId/items/',
		requestOptions: {
			method: 'POST',
		},
	},

	[ModulesConfigMap[ModulesMap.CARGO_ITEMS].PUT_CARGO_ITEM]: {
		url: '/company/:companyId/cargo/:cargoId/items/:cargoItemId/',
		requestOptions: {
			method: 'PUT',
		},
	},

	[ModulesConfigMap[ModulesMap.CARGO_ITEMS].PATCH_CARGO_ITEM]: {
		url: '/company/:companyId/cargo/:cargoId/items/:cargoItemId/',
		requestOptions: {
			method: 'PATCH',
		},
	},

	[ModulesConfigMap[ModulesMap.CARGO_ITEMS].DELETE_CARGO_ITEM]: {
		url: '/company/:companyId/cargo/:cargoId/items/:cargoItemId/',
		requestOptions: {
			method: 'DELETE',
		},
	},

}